import React from 'react';
import { useSelector } from 'react-redux';
import { getManuals } from 'features/product-info';
import { cx } from 'linaria';
import { pdpSectionStyle } from 'common/components/page-section';
import { isURL } from 'entries/server/utils';
import { ManualItem } from './manual-item';
import { DATA_QA_MANUALS, DATA_QA_MANUALS_EMPTY_BLOCK, DATA_QA_MANUALS_WRAP } from './constants';
import { manualsInnerWrap, manualsOuterWrap, EmptyBlock } from './manuals.styles';

export const Manuals = () => {
  const manuals = useSelector(getManuals);
  const allUrlsInvalid = manuals?.every(({ url }) => !isURL(url ?? ''));

  if (!manuals || !manuals.length || allUrlsInvalid) {
    return <EmptyBlock data-qa={DATA_QA_MANUALS_EMPTY_BLOCK} />;
  }

  return (
    <div className={cx(pdpSectionStyle, manualsOuterWrap)} data-qa={DATA_QA_MANUALS_WRAP}>
      <div className={manualsInnerWrap} data-qa={DATA_QA_MANUALS}>
        {manuals.map(({ url, filesize }, idx) => {
          if (!isURL(url ?? '')) return;

          return (
            <ManualItem
              key={url}
              url={url ?? ''}
              filesize={filesize}
              idx={idx}
              manualsLength={manuals.length}
            />
          );
        })}
      </div>
    </div>
  );
};
